module.exports = __webpack_public_path__ + "img/1482560932.37a98d13.jpg";